import React from 'react';
import '../assets/css/for_your_company_new.css';
import PlansCompany from '../components/ForYourCompanyNew/PlansCompany';
import Contact from '../components/HomePageNew/Contact';
import Footer from '../components/HomePageNew/Footer';

const ForYourCompanyNew = () => {
  
  return (
    <div>
      <PlansCompany/>
      <Contact/>
      <Footer/>
    </div>
  );
};

export default ForYourCompanyNew;



/** WEBPACK FOOTER **
 ** ./src/containers/ForYourCompanyNew.js
 **/